module.exports = __webpack_public_path__ + "img/linkedIn.1d62cd53.svg";